import localforage from "localforage";

/**
 * Liste des puces OTAG déjà utilisées, renvoyée par GET /otags3.
 *
 * Renvoie null quand la réponse ne doit pas remplacer le cache local 'OTAGS' :
 * socom indisponible (`disponible: false`, MD-772) ou réponse sans tableau
 * (ex. erreur 500). Écraser le cache viderait la liste et désactiverait le
 * contrôle « puce OTAG déjà utilisée » au scan.
 */
export function otagsExploitables(payload) {
    if (!payload || payload.disponible === false || !Array.isArray(payload.otags)) {
        return null;
    }

    return payload.otags;
}

/**
 * Met à jour le cache 'OTAGS' seulement si la réponse est exploitable.
 * Résout true si le cache a été écrit, false s'il a été conservé.
 */
export function enregistrerOtags(payload) {
    const otags = otagsExploitables(payload);
    if (otags === null) {
        return Promise.resolve(false);
    }

    return localforage
        .setItem('OTAGS', JSON.stringify(otags))
        .then(() => true);
}



// WEBPACK FOOTER //
// ./src/js/core/Otags.js